module.exports = __webpack_public_path__ + "static/a-5180058c64635931ebd7466b7b49df8b.jpg";